module.exports = __webpack_public_path__ + "img/add_to_cart.c1209375.svg";